import { Link, useLocation } from "react-router-dom";
import {
  SquareChartGantt,
  Siren,
  Users,
  RadioTower,
  BellRing,
  MapPinned,
  MessageCircle,
  MapPlus,
  AreaChart,
  Proportions
} from "lucide-react";
import Logo from "../Assets/Shipra Logo.png";

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();

  const menuItems = [
    { path: "/", label: "Overview", icon: <SquareChartGantt /> },
    { path: "/emergencies", label: "Emergencies", icon: <Siren /> },
    { path: "/lost-found", label: "Lost & Found", icon: <Users /> },
    {
      path: "/add-points",
      label: "Add Points",
      icon: <MapPinned />,
    },
    {
      path: "/live-updates",
      label: "Live Updates",
      icon: <RadioTower />,
    },
    { path: "/view-updates", label: "View Updates", icon: <BellRing /> },
    { path: "/feedbacks", label: "Feedbacks", icon: <MessageCircle /> },
    { path: "/points-insight", label: "Point's Insight", icon: <AreaChart /> },
    {
      path: "/crowd-insights",
      label: "Crowd Insights",
      icon: <MapPlus />,
    },{
      path: "/reports",
      label: "Reports",
      icon: <Proportions />,
    },
  ];

  return (
    <div className={`sidebar ${isOpen ? "open" : "closed"}`}>
      <div className="sidebar-header">
        <div className="brandingBox">
          <img
            src={Logo}
            alt="Shipra Admin Dashboard"
            title="Shipra Admin Dashboard"
          />
          <h3 className="sidebar-title" style={{ marginTop: "1px" }}>
            Shipra Admin
          </h3>
        </div>
        <button className="toggle-button" onClick={toggleSidebar}>
          ☰
        </button>
      </div>
      <nav className="nav">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`nav-link ${
              location.pathname === item.path ? "active" : ""
            }`}
          >
            <span className="nav-icon">{item.icon}</span>
            {item.label}
          </Link>
        ))}
      </nav>
      <div className="admin-login">
        <a
          href="https://mail.google.com/mail/?view=cm&fs=1&to=support@triosoft.ai"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="login-button">Help & Support</button>
        </a>
      </div>
    </div>
  );
};

export default Sidebar;
